export const ROUTES = {
  CONVERATION_BUILDER: 'conversationBuilder',
  BOT_PLATFORM: 'botPlatform',
  LIVE_INTENT: 'intentAnalyzer',
  LANDING: 'landing',
};

export const CB_ROUTES = {
  BOT_BUILDER: 'botBuilder', // bot builder
  KNOWLEDGE_BASE: 'knowledgeBase', // knowledge base
  DOMAINS: 'intentBuilder', // intent builder
  ANALYTICS: 'botAnalytics', // bot analytics
  SYS_ADMIN: 'botStatus', // bot status
  ORG_MGMT: 'botAccounts', // bot accounts
};

export const CB_ROUTES_INVERT = {
  botBuilder: 'BOT_BUILDER',
  knowledgeBase: 'KNOWLEDGE_BASE',
  intentBuilder: 'DOMAINS',
  botAnalytics: 'ANALYTICS',
  botStatus: 'SYS_ADMIN',
  botAccounts: 'ORG_MGMT',
};
